module.exports = __webpack_public_path__ + "mn.svg?30e30d5acd1696b63084ea89a7d1ede3";